/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 12l6 0", "key": "svg-1" }]];
const IconCircleMinus = createReactComponent("outline", "circle-minus", "CircleMinus", __iconNode);

export { __iconNode, IconCircleMinus as default };
//# sourceMappingURL=IconCircleMinus.mjs.map
